<div fxLayout="column" fxLayoutGap="46px">
    <span class="title">Excluir?</span>

    <!-- <app-project-card [canInteract]="false" [project]="data"></app-project-card> -->
    <mat-card appearance="outlined" class="card pointer">
        <mat-card-content>
            <span class="title">{{data.name}}</span>
        </mat-card-content>
    </mat-card>

    <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="end center">
        <app-button [txt]="'CANCELAR'" [class]="'no-border'" (click)="dismiss()"></app-button>

        <app-button [txt]="'EXCLUIR'" [class]="'border-blue-filled'" (click)="submit()"> </app-button>
    </div>
</div>